import Proxy from './Proxy';

class AccountsProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/settings/accounts', parameters);
  }

  /**
   * 로그인 사용자 메뉴 가져오기
   * @returns {Promise}
   */
  findAll() {
    return this.submit('get', `/${this.endpoint}`);
  }

  findReadyUser() {
    return this.submit('get', `/${this.endpoint}/ready-user/list`)
  }  

  createSubUser( data ) {
    
    return this.submit('post', `/${this.endpoint}/sub-user/create`, data )
  }

  updateSubUser( data ) {
    return this.submit('put', `/${this.endpoint}/sub-user/${data.userId}`, data )
  }

  getSubUserList( companySeq ) {
    return this.submit('get', `/${this.endpoint}/sub-user-list/${companySeq}` )
  }

  getMasterUser( companySeq ) {
    return this.submit('get', `/${this.endpoint}/master-user/${companySeq}`);
  }

  changeUserStatus( userId, status ) {
    return this.submit('post', `/${this.endpoint}/change-user-status`,{userId, status});
  }  

}

export default AccountsProxy;
